module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ServiceForm', {
    attrs: {
      "formData": _vm.data,
      "func": _vm.funcType,
      "isUpdate": _vm.isUpdate
    },
    on: {
      "submitData": function($event) {
        return _vm.submitData($event)
      }
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-38be3600!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/welcomeSetting/ServiceCreate.vue
// module id = Q++x
// module chunks = 4